export const PERMISSIONS = `/api/auth/permissions` ;
export const APP_PERMISSIONS = `/api/iam/security` ;
export const REFRESH_TOKEN = `/jwt-auth-refresh`;
